<script>
  export let data
  import Page from "$lib/layouts/page.svelte";
  import { currentAppUser } from "$lib/pocketbase"
  import { shows } from "$lib/i18n"
  if (data.settings) shows.set(data.settings.filter(setting => setting.key.includes("de") || setting.key.includes("en")))
</script>

<Page title="{`Welcome to \n Commune AI`}" background="#8100F3">
  <div class="mx-auto flex justify-center gap-8">
    {#if !$currentAppUser}
      <a data-sveltekit-reload href="/auth/login" class="btn-ai">
        Login
      </a>
      <a data-sveltekit-reload href="/auth/register" class="btn-ai">
        Register
      </a>
    {:else}
      <a data-sveltekit-reload href="/shows" class="btn-ai">
        Go to show
      </a>
      <a data-sveltekit-reload href="/auth/logout" class="btn-ai">
        Log out
      </a>
    {/if}
  </div>

  <div slot="background-content" class="fixed bottom-0 right-0 w-1/3">
    <img class="w-full" src="/pages/home.png" alt="Welcome to Commune AI">
  </div>
</Page>